import { Button, Checkbox, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";

const AddSubDomainModal = ({
    open,
    setOpen,
    selectedBusiness,
    onSubmit
}) => {
    const [loading, setLoading] = useState(false);
    const [selectedSubdomains, setSelectedSubdomains] = useState([]);
    const [availableSubdomains, setAvailableSubdomains] = useState([]);

    useEffect(() => {
        if (open && selectedBusiness) {
            extractBimehSubdomains();
        }
    }, [open, selectedBusiness]);

    const extractBimehSubdomains = () => {
        if (!selectedBusiness?.domain) {
            setAvailableSubdomains([]);
            return;
        }

        const domains = selectedBusiness.domain
            .split(",")
            .map(d => d.trim())
            .filter(d => d && d.endsWith(".bimeh.com"));

        setAvailableSubdomains(domains);
        setSelectedSubdomains([]);
    };

    const handleCheckboxChange = (subdomain, checked) => {
        if (checked) {
            setSelectedSubdomains(prev => [...prev, subdomain]);
        } else {
            setSelectedSubdomains(prev => prev.filter(s => s !== subdomain));
        }
    };

    const handleSubmit = async () => {
        if (selectedSubdomains.length === 0) return;

        setLoading(true);
        try {
            // Extract only the prefix (x from x.bimeh.com)
            const subdomainPrefixes = selectedSubdomains.map(domain => {
                return domain.replace('.bimeh.com', '');
            });

            await onSubmit(subdomainPrefixes);
            handleClose();
        } catch (error) {
            console.error("Error adding subdomains:", error);
        } finally {
            setLoading(false);
        }
    };


    const handleClose = () => {
        setOpen(false);
        setSelectedSubdomains([]);
        setAvailableSubdomains([]);
    };

    return (
        <Modal
            title="افزودن ساب‌دامین‌(ها)"
            open={open}
            onCancel={handleClose}
            footer={[
                <Button key="cancel" onClick={handleClose} disabled={loading}>
                    انصراف
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    disabled={selectedSubdomains.length === 0 || loading}
                    onClick={handleSubmit}
                    loading={loading}
                >
                    ثبت ({selectedSubdomains.length})
                </Button>
            ]}
        >
            {availableSubdomains.length === 0 ? (
                <div style={{ textAlign: "center", padding: "20px 0", color: "#999" }}>
                    هیچ ساب‌دامین bimeh.com یافت نشد
                </div>
            ) : (
                <>
                    <div style={{ marginBottom: 16, color: "#666" }}>
                        ساب‌دامین‌های موجود در بیزنس <strong>{selectedBusiness?.name}</strong>:
                    </div>
                    <div style={{ maxHeight: 300, overflowY: "auto" }}>
                        {availableSubdomains.map((subdomain) => (
                            <div
                                key={subdomain}
                                style={{
                                    padding: "8px 12px",
                                    borderBottom: "1px solid #f0f0f0"
                                }}
                            >
                                <Checkbox
                                    checked={selectedSubdomains.includes(subdomain)}
                                    onChange={(e) => handleCheckboxChange(subdomain, e.target.checked)}
                                >
                                    {subdomain}
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </Modal>
    );
};

export default AddSubDomainModal;
